module.exports = __webpack_public_path__ + "media/images/brand/photo05-ea311ed4f695730c346f8191429f4cc4.png";